class ObjectUtils {
    clone<T>(o: T): T {
        return JSON.parse(JSON.stringify(o));
    }

    range(n: number) {
        return Array.from(Array(n).keys());
    }

    private enumKeys<T extends object>(enumLike: T) {
        return Object.keys(enumLike) as Array<keyof typeof enumLike>;
    }

    enumNumberKeys<T extends object>(enumLike: T) {
        return this.enumKeys(enumLike)
            .filter((a) => !isNaN(Number(a)))
            .map((a) => Number(a));
    }

    enumStringKeys<T extends object>(enumLike: T) {
        return this.enumKeys(enumLike)
            .filter((a) => isNaN(Number(a)))
            .map((a) => a.toString() as keyof T);
    }

    groupBy<T>(list: T[], key: string) {
        const group = new Map<string, T[]>();

        list.forEach((e) => {
            if (group.has((e as any)[key])) {
                group.get((e as any)[key])?.push(e);
                return;
            }

            group.set((e as any)[key], [e]);
        });
        return group;
    }

    async fromBase64ToBlob(b64: string) {
        return fetch(b64).then((res) => res.blob());
    }

    softIncludes<T>(a: T[], b: T[]) {
        return (
            a.some((item) => b.includes(item)) &&
            b.some((item) => a.includes(item))
        );
    }
}
const objectUtils = new ObjectUtils();

export default objectUtils;
